import {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import moment from "moment";
import toast from "react-hot-toast";

import "./AssignmentOfBenefit.css";

import { GragIntakeSheetData } from "./Service";
import {
  AOBConstant,
  IntakeSheetSession,
  // providerData,
  RoleType,
} from "../../../helpers/constant";
import {
  GetCaseFormListData,
  SaveCaseFormData,
} from "../medicalLien/services3";
import SignaturePad from "../../../Component/shared/signaturePad";
import SpinnerLoader from "../../../Component/shared/loader/spinnerLoader/SpinnerLoader";
import {CallApiForProviderList } from "../IntakeSheetUtils";
import { usePatientData } from "../../../commonFunction/storage/Patientdatacontext";


function setInCollection(collection, name, value) {
  const item = collection.find((x) => x.Name === name);
  if (item) item.Value = value;
}

// const tokenData = JSON.parse(sessionStorage.getItem("tokenData") || "{}");

const AssignmentsOfBenifit = forwardRef(
  function AssignmentsOfBenifit(props, ref) {
    const {
      providerOptions = [],
      sessionData = {},
      signatureMiss,
      copySignature,
      intakeSheet,
      onReady,
    } = props;

    const tokenData = JSON.parse(sessionStorage.getItem("tokenData") || "{}");

    const { patientData, fetchPatientData } = usePatientData();
    /* ── state ── */
    const [loading, setLoading] = useState(false);
    const [CaseFormDataId, setCaseFormDataId] = useState(""); // matches HippaAuth naming
    const [collectionOfAOB, setCollectionOfAOB] = useState([]);
    const [BeforeParsingAOBData, setBeforeParsingAOBData] = useState([]); // matches HippaAuth naming
    const [name, setName] = useState("");
    const [assignTo, setAssignTo] = useState("");
    const [accidentDate, setAccidentDate] = useState("");
    const [patientName, setPatientName] = useState("");
    const [providerName, setProviderName] = useState(""); // eslint-disable-line no-unused-vars
    const [patientAddress, setPatientAddress] = useState("");
    const [providerAddress, setProviderAddress] = useState("");
    const [patientSignImg, setPatientSignImg] = useState("");
    const [providerSignImg, setProviderSignImg] = useState("");
    const [patientSignDate, setPatientSignDate] = useState(new Date());
   const [providerSignDate, setProviderSignDate] = useState(null);
    const [selectedProvider, setSelectedProvider] = useState(providerOptions[0] || null,);
    const [isSelectedProvider, setIsSelectedProvider] = useState(false); // eslint-disable-line no-unused-vars
    const [signRole, setSignRole] = useState("");
    const [sigPadOpen, setSigPadOpen] = useState(false);



    useEffect(() => {
      callApi();
    }, [patientData]);

    useEffect(() => {
    onReady?.("aob");
    }, [patientSignImg]);

    useImperativeHandle(ref, () => ({
      save:           () => saveFunction(true),
      isPending:      () => !patientSignImg,
       getSignature:   () => patientSignImg || "",   
      applySignature: (sig) => {
        if (!sig) return;
        setPatientSignImg(sig);
        setPatientSignDate(new Date());
      },    // }), [patientSignImg]);
    }), [patientSignImg, patientSignDate]);

    const callApi = async () => {
      setLoading(true);
      const formData = await handleGetCaseFormData();
          const patientInfo = patientData || await fetchPatientData(tokenData?.caseId, tokenData?.companyId);
          const providerData = await CallApiForProviderList(
            tokenData?.companyId,
            tokenData?.providerId,
          );
      if (!formData?.JsonData) {
        console.error("No JsonData returned from GetCaseFormListData");
        setLoading(false);
        return;
      }

      const AOBData = JSON.parse(formData.JsonData);
      const collection = GragIntakeSheetData(AOBData);

      setCollectionOfAOB(collection);
      setBeforeParsingAOBData(AOBData);
      setCaseFormDataId(formData.CaseFormDataId);

      bindValueToControl(collection, patientInfo, providerData);
      setLoading(false);
      // Notify parent that data is loaded so it can check pending status accurately
      // onReady?.("aob");
    };

    const handleGetCaseFormData = async () => {
      try {
        const requestBody = {
          CaseFormDataId: null,
          CaseId: tokenData.caseId,
          CompanyId: tokenData.companyId,
          DoctorId: "ALL",
          EntityLevel: 0,
          FormId: 1,
          FormName: "Assignment of Benefits",
          FormType: null,
          IsFormCompleted: false,
          JsonData: null,
          TemplateName: null,
          UserId: "US000000000000012172",
        };

        const response = await GetCaseFormListData(requestBody);

        if (response?.HasException) {
          toast.error(
            `Something went wrong. ${response?.MessageText}. ${response?.Exception}`,
          );
          return {};
        }
        return response?.Data?.[0] || {};
      } catch (error) {
        toast.error(error.message);
        return {};
      }
    };


    const CallSaveApiForIntakeSheet = async (jsonData) => {
      try {
        // setLoading(true);
        const payload = {
          CaseFormDataId: CaseFormDataId,
          CaseId: tokenData.caseId,
          CompanyId: tokenData.companyId,
          DoctorId: tokenData.doctorId,
          EntityLevel: 0,
          FormId: 1,
          FormName: "Assignment of Benefits",
          FormType: null,
          IsChanged: false,
          IsCopySign: false,
          IsFormCompleted: false,
          TemplateName: null,
          UserId: tokenData.userId ,
          officeId: tokenData.providerId,
          JsonData: jsonData,
        };

        const response = await SaveCaseFormData(payload);

        if (response?.HasException) {
          toast.error(
            `Error while saving Assignment of Benefits. ${response?.MessageText || ""}`,
          );
          return false;
        } else {
          if (response?.Data?.[0]?.CaseFormDataId) {
            setCaseFormDataId(response.Data[0].CaseFormDataId);
          }
          toast.success("Assignment of Benefits saved successfully.");
          return true;
        }
      } catch (err) {
        console.error("CallSaveApiForIntakeSheet error:", err);
        toast.error("Error while saving Assignment of Benefits data.");
        return false;
      } finally {
        // setLoading(false);
      }
    };

    const createProviderInfoView = (providerData) => {
      const { Address, Street, City, State, Zip } = providerData;
      return [Address, Street, City, State, Zip].filter(Boolean).join(", ");
    };

    const generatePatientAddress = (patientInfo) => {
    const {
      patientAddress,
      patientStreet,
      patientCity,
      patientStateName,
      patientZip,
    } = patientInfo;
    return [
      patientAddress,
      patientStreet,
      patientCity,
      patientStateName,
      patientZip,
    ]
      .filter(Boolean)
      .join(", ");
  };

    const bindValueToControl = (collection, patientInfo, providerData) => {
      if (!patientInfo) return;
      const filterData = (key) => {
        const item = collection.find((x) => x.Name === key);
        const val = item ? item.Value : "";
        return val === "01/01/1900" ? "" : val;
      };

      const normalise = (raw) =>
        !raw
          ? ""
          : raw.includes(IntakeSheetSession.dataBlock)
            ? raw
            : IntakeSheetSession.dataBlock + raw;

      const parseDateSafe = (raw) =>
  isNaN(new Date(raw).getTime()) ? null : new Date(raw);

      // Patient fields
      const fullName = [
        patientInfo.patientFirstName,
        patientInfo.patientMiddleName,
        patientInfo.patientLastName,
      ]
        .filter(Boolean)
        .join(" ");

      const doa = patientInfo.patientDOA
        ? moment(patientInfo.patientDOA).format("MM/DD/YYYY")
        : "";


        setProviderName(providerData?.ProviderName || "");
        setAssignTo(providerData?.ProviderName || "");
        setProviderAddress(createProviderInfoView(providerData));

      if (fullName) {
        setName(fullName);
        setPatientName(fullName);
      }
       setPatientAddress(generatePatientAddress(patientInfo));
      if (doa) setAccidentDate(doa);

      const savedSig = copySignature ? sessionStorage.getItem("sharedPatientSignature") : null;
      setPatientSignImg(savedSig || normalise(filterData(AOBConstant.PatientSign)));  
      // setPatientSignImg(normalise(filterData(AOBConstant.PatientSign)));
      setProviderSignImg(normalise(filterData(AOBConstant.ProviderSign)));
      setPatientSignDate(
        parseDateSafe(filterData(AOBConstant.PatientSignDate)) || new Date(),
      );
      const savedProviderDate = parseDateSafe(
  filterData(AOBConstant.ProviderSignDate)
);

setProviderSignDate(savedProviderDate || null);

      if (!filterData(AOBConstant.PatientSign)) signatureMiss?.(true);
      setLoading(false);
    };

    const updateCollection = (collection) => {
      try {
        const updated = [...collection];

        const set = (key, value) => {
          const item = updated.find((x) => x.Name === key);
          if (item) item.Value = value;
        };

        const fmt = (d) =>
          d == null || d === ""
            ? ""
            : moment(d).format("MM-DD-YYYY").split("-").join("/");

        set(AOBConstant.PatientName, name);
        set(AOBConstant.PatientDOA, accidentDate);
        set(AOBConstant.PatientName2, patientName);
        set(AOBConstant.PatientAddress, patientAddress);
        set(AOBConstant.ProviderAddress, providerAddress);
        set(AOBConstant.PatientSign, patientSignImg);
        set(AOBConstant.ProviderSign, providerSignImg);
        set(AOBConstant.PatientSignDate, fmt(patientSignDate));
        set(AOBConstant.ProviderSignDate, fmt(providerSignDate));
        set(AOBConstant.ProviderName, tokenData?.providerName);
        set(AOBConstant.ProviderName2, tokenData?.providerName);

        return updated;
      } catch (error) {
        error.console(error?.message);
      }
    };


    const formJsonRequest = async (updatedCollection, beforeData) => {
      try {
        for (let i = 0; i < beforeData.notesdata.length; i++) {
          const filterDataArr = updatedCollection.filter(
            (x) => x.RenderKeyName === beforeData.notesdata[i].RenderKeyName,
          );
          if (!filterDataArr.length) continue;

          for (
            let j = 0;
            j < beforeData.notesdata[i].ApplicationValue.length;
            j++
          ) {
            if (
              beforeData.notesdata[i].ApplicationValue[j].Name !==
              filterDataArr[j]?.Name
            )
              continue;

            beforeData.notesdata[i].ApplicationValue[j].Type =
              filterDataArr[j].Type;
            beforeData.notesdata[i].ApplicationValue[j].isRender =
              filterDataArr[j].isRender;

            const isSign =
              beforeData.notesdata[i].ApplicationValue[j].Name ===
                AOBConstant.PatientSign ||
              beforeData.notesdata[i].ApplicationValue[j].Name ===
                AOBConstant.ProviderSign;

            if (isSign) {
              const val = filterDataArr[j].Value;
              if (val) {
                if (val.includes(";")) {
                  beforeData.notesdata[i].ApplicationValue[j].Value = val
                    .split(";")[1]
                    .split(",")[1];
                } else {
                  beforeData.notesdata[i].ApplicationValue[j].Value = val;
                }
              } else {
                beforeData.notesdata[i].ApplicationValue[j].Value = "";
              }
            } else {
              beforeData.notesdata[i].ApplicationValue[j].Value =
                filterDataArr[j].Value;
            }
          }
        }
        const result = await CallSaveApiForIntakeSheet(
          JSON.stringify(beforeData),
        );
        setCollectionOfAOB(updatedCollection);
        setBeforeParsingAOBData(beforeData);
        return result;
      } catch (error) {
        console.error(error?.message);
      }
    };

    const saveFunction = async () => {
      setLoading(true);
      const updatedCollection = updateCollection(collectionOfAOB);
      const beforeDataClone = JSON.parse(JSON.stringify(BeforeParsingAOBData));
      const result = await formJsonRequest(updatedCollection, beforeDataClone);
      setLoading(false);
      return result;
    };

    const clickPatientSign = () => {
      setSignRole(RoleType.Patient);
      setSigPadOpen(true);
    };
    const clickProviderSign = () => {
      setSignRole(RoleType.provider);
      setSigPadOpen(true);
    };

    const signUpdatedCall = (base64Img) => {
      const newBase = base64Img.includes(IntakeSheetSession.dataBlock1)
        ? base64Img.replace(
            IntakeSheetSession.dataBlock1,
            IntakeSheetSession.dataBlock,
          )
        : base64Img;
      if (signRole === RoleType.provider || signRole === RoleType.FrontDesk) {
        setProviderSignImg(newBase);
        setProviderSignDate(new Date());
      }
      if (signRole === RoleType.Patient) {
        setPatientSignImg(newBase);
        setPatientSignDate(new Date());
        sessionStorage.setItem("sharedPatientSignature", newBase); // CHANGED
      }
    };

    const clearSignCall = () => {
      if (signRole === RoleType.Patient) {
        setPatientSignImg("");
        setPatientSignDate("");
        signatureMiss?.(true);
      }
      if (signRole === RoleType.provider) {
        setProviderSignImg("");
        setProviderSignDate(null);
      }
    };
    const customSingleValue = ({ data }) => <div>{data?.officeName}</div>;
    const customOption = (o) => <div {...o.innerProps}>{o.data.label}</div>;

    const ProviderField = () =>
      providerOptions.length === 1 ? (
        <input
          className="aob__input"
          type="text"
          value={assignTo}
          onChange={(e) => setAssignTo(e.target.value)}
        />
      ) : (
        <div className="aob__select">
          <Select
            options={providerOptions}
            // onChange={onProviderChange}
            value={selectedProvider}
            getOptionLabel={(e) => e?.label}
            getOptionValue={(e) => e?.value}
            tabSelectsValue={false}
            components={{
              SingleValue: customSingleValue,
              Option: customOption,
            }}
            classNamePrefix="react-select"
          />
        </div>
      );

    return (
      <>
        {loading ? (
          <SpinnerLoader message="Loading form data…" />
        ) : (
          <div className="aob__wrapper">
            {/* ── Title ── */}
            <div className="aob__title-block">
              <div className="aob__title-main">
                NEW YORK MOTOR VEHICLE NO-FAULT INSURANCE LAW
              </div>
              <div className="aob__title-sub">ASSIGNMENT OF BENEFITS FORM</div>
              <div className="aob__title-note">
                (FOR ACCIDENTS OCCURRING ON AND AFTER 3/1/02)
              </div>
            </div>

            {/* ── Row 1 — inline sentence ── */}
            <div className="aob__sentence-row">
              <span className="aob__sentence-word">I,</span>

              <div className="aob__sentence-field">
                <input
                  className="aob__input"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  disabled
                />
                <div className="aob__field-hint">(Print patient's name)</div>
              </div>

              <span className="aob__sentence-word">
                ,("Assignor") hereby assign to
              </span>

              <div className="aob__sentence-field">
                {/* {isFrontDesk ? (
                  <ProviderField />
                ) : ( */}
                  <input
                    className="aob__input"
                    type="text"
                    value={assignTo}
                    onChange={(e) => setAssignTo(e.target.value)}
                    disabled
                  />
                {/* )} */}
                <div className="aob__field-hint">
                  (Print hospital or health care provider name)
                </div>
              </div>

              <span className="aob__sentence-word">, ("Assignee")</span>
            </div>

            {/* ── Legal panel ── */}
            <div className="aob__legal-panel">
              <p>
                <b>
                  all rights privileges and remedies to payment for health care
                  services provided by assignee to which I am entitled under
                  Article 51 (the No-Fault statute) of the Insurance Law.
                </b>
              </p>
              <p>
                <b>
                  The Assignee hereby certifies that they have not received any
                  payment from or on behalf of the Assignor and shall not pursue
                  payment directly from the Assignor for services provided by
                  said Assignee for injuries sustained due to the motor vehicle
                  accident which occurred on,
                  not withstanding any other agreement to the contrary.
                </b>
              </p>
              <p>
                <b>
                  This agreement may be revoked by the assignee when benefits
                  are not payable based upon the assignor's lack of coverage
                  and/or violation of a policy condition due to the actions or
                  conduct of the assignor.
                </b>
              </p>
              <div className="aob__legal-box">
                <b>
                  ANY PERSON WHO KNOWINGLY AND WITH INTENT TO DEFRAUD ANY
                  INSURANCE COMPANY OR OTHER PERSON FILES AN APPLICATION FOR
                  COMMERCIAL INSURANCE OR A STATEMENT OF CLAIM FOR ANY
                  COMMERCIAL OR PERSONAL INSURANCE BENEFITS CONTAINING ANY
                  MATERIALLY FALSE INFORMATION, OR CONCEALS FOR THE PURPOSE OF
                  MISLEADING, INFORMATION CONCERNING ANY FACT MATERIAL THERETO,
                  AND ANY PERSON WHO, IN CONNECTION WITH SUCH APPLICATION OR
                  CLAIM, KNOWINGLY MAKES OR KNOWINGLY ASSISTS, ABETS, SOLICITS
                  OR CONSPIRES WITH ANOTHER TO MAKE A FALSE REPORT OF THE THEFT,
                  DESTRUCTION, DAMAGE OR CONVERSION OF ANY MOTOR VEHICLE TO A
                  LAW ENFORCEMENT AGENCY, THE DEPARTMENT OF MOTOR VEHICLES OR AN
                  INSURANCE COMPANY, COMMITS A FRAUDULENT INSURANCE ACT, WHICH
                  IS A CRIME, AND SHALL ALSO BE SUBJECT TO A CIVIL PENALTY NOT
                  TO EXCEED FIVE THOUSAND DOLLARS AND THE VALUE OF THE SUBJECT
                  MOTOR VEHICLE OR STATED CLAIM FOR EACH VIOLATION.
                </b>
              </div>
            </div>

            {/* ── Name row ── */}
            <div className="aob__grid-row">
              <span className="aob__grid-label">
                <b>Name :</b>
              </span>
              <div>
                <input
                  className="aob__input"
                  type="text"
                  value={patientName}
                  onChange={(e) => setPatientName(e.target.value)}
                  disabled
                />
              </div>
              <span className="aob__grid-label">
                <b>Name Of Provider:</b>
              </span>
              <div>
                {/* {isFrontDesk ? (
                  <ProviderField />
                ) : ( */}
                  <input
                    className="aob__input"
                    type="text"
                    value={providerName}
                    onChange={(e) => setAssignTo(e.target.value)}
                    disabled
                  />
                {/* )} */}
              </div>
            </div>

            {/* ── Address row ── */}
            <div className="aob__grid-row">
              <span className="aob__grid-label">
                <b>Address  :</b>
              </span>
              <div>
                <textarea
                  className="aob__textarea"
                  value={patientAddress}
                  onChange={(e) => setPatientAddress(e.target.value)}
                  disabled
                />
              </div>
              <span className="aob__grid-label">
                <b>Address Of Provider:</b>
              </span>
              <div>
                <textarea
                  className="aob__textarea"
                  value={providerAddress}
                  disabled
                />
              </div>
            </div>

            {/* ── Signatures header ── */}
            <div className="aob__section">
              <span className="aob__section-title">Signatures</span>
              <span className="aob__section-line" />
            </div>

            {/* ── Signature boxes ── */}
            <div className="aob__grid-row">
              <span className="aob__grid-label">
                <b>Signature :</b>
              </span>
              <div>
                <div
                  className={`aob__sign-box${!patientSignImg ? " aob__sign-box--empty" : ""}`}
                  onClick={clickPatientSign}
                >
                  {patientSignImg && (
                    <img
                      src={patientSignImg}
                      alt="Patient signature"
                      className="aob__sign-img"
                    />
                  )}
                </div>
              </div>
              <span className="aob__grid-label">
                <b>Signature Of Provider:</b>
              </span>
              <div>
                {/* <div
            className={`aob__sign-box${!providerSignImg ? " aob__sign-box--empty" : ""}`}
            onClick={clickProviderSign}
          >
            {providerSignImg && (
              <img src={providerSignImg} alt="Provider signature" className="aob__sign-img" />
            )}
          </div> */}
                <div
                  className="aob__sign-box aob__sign-box--disabled"
                >
                  {providerSignImg && (
                    <img
                      src={providerSignImg}
                      alt="Provider signature"
                      className="aob__sign-img"
                    />
                  )}
                </div>
              </div>
            </div>

            {/* ── Signature dates ── */}
            <div
              className="aob__grid-row aob__grid-row--center"
            >
              <span className="aob__grid-label">
                <b>Date of Signature:</b>
              </span>
              <div>
                <DatePicker
                  selected={patientSignDate}
                  onChange={(d) => setPatientSignDate(d)}
                  dateFormat="MM/dd/yyyy"
                  className="aob__datepicker"
                  showYearDropdown
                  showMonthDropdown
                  dropdownMode="select"
                />
              </div>
              <span className="aob__grid-label">
                <b>Date of Provider Signature:</b>
              </span>
              <div>
                <DatePicker
                  selected={providerSignDate}
                  onChange={(d) => setProviderSignDate(d)}
                  dateFormat="MM/dd/yyyy"
                  className="aob__datepicker"
                  showYearDropdown
                  showMonthDropdown
                  dropdownMode="select"
                  disabled
                />
              </div>
            </div>

            {/* ── Signature Pad Modal ── */}
            <SignaturePad
              isOpen={sigPadOpen}
              title={
                signRole === RoleType.Patient
                  ? "Patient Signature"
                  : "Provider Signature"
              }
              existingSign={
                signRole === RoleType.Patient ? patientSignImg : providerSignImg
              }
              onClose={() => setSigPadOpen(false)}
              onSave={(base64) => {
                signUpdatedCall(base64);
                setSigPadOpen(false);
              }}
              onClear={clearSignCall}
            />
          </div>
        )}
      </>
    );
  },
);

export default AssignmentsOfBenifit;